import React, { useState, useRef, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { NavLink } from 'react-router-dom';
import NextButton from './components/NextButton';
import PaymentMethodPage from './PaymentMethodPage';

const states = [
  { code: 'AL', name: 'Alabama' },
  { code: 'AK', name: 'Alaska' },
  { code: 'AZ', name: 'Arizona' },
  { code: 'AR', name: 'Arkansas' },
  { code: 'CA', name: 'California' },
  { code: 'CO', name: 'Colorado' },
  { code: 'CT', name: 'Connecticut' },
  { code: 'DE', name: 'Delaware' },
  { code: 'DC', name: 'District of Columbia' },
  { code: 'FL', name: 'Florida' },
  { code: 'GA', name: 'Georgia' },
  { code: 'HI', name: 'Hawaii' },
  { code: 'ID', name: 'Idaho' },
  { code: 'IL', name: 'Illinois' },
  { code: 'IN', name: 'Indiana' },
  { code: 'IA', name: 'Iowa' },
  { code: 'KS', name: 'Kansas' },
  { code: 'KY', name: 'Kentucky' },
  { code: 'LA', name: 'Louisiana' },
  { code: 'ME', name: 'Maine' },
  { code: 'MD', name: 'Maryland' },
  { code: 'MA', name: 'Massachusetts' },
  { code: 'MI', name: 'Michigan' },
  { code: 'MN', name: 'Minnesota' },
  { code: 'MS', name: 'Mississippi' },
  { code: 'MO', name: 'Missouri' },
  { code: 'MT', name: 'Montana' },
  { code: 'NE', name: 'Nebraska' },
  { code: 'NV', name: 'Nevada' },
  { code: 'NH', name: 'New Hampshire' },
  { code: 'NJ', name: 'New Jersey' },
  { code: 'NM', name: 'New Mexico' },
  { code: 'NY', name: 'New York' },
  { code: 'NC', name: 'North Carolina' },
  { code: 'ND', name: 'North Dakota' },
  { code: 'OH', name: 'Ohio' },
  { code: 'OK', name: 'Oklahoma' },
  { code: 'OR', name: 'Oregon' },
  { code: 'PA', name: 'Pennsylvania' },
  { code: 'RI', name: 'Rhode Island' },
  { code: 'SC', name: 'South Carolina' },
  { code: 'SD', name: 'South Dakota' },
  { code: 'TN', name: 'Tennessee' },
  { code: 'TX', name: 'Texas' },
  { code: 'UT', name: 'Utah' },
  { code: 'VT', name: 'Vermont' },
  { code: 'VA', name: 'Virginia' },
  { code: 'WA', name: 'Washington' },
  { code: 'WV', name: 'West Virginia' },
  { code: 'WI', name: 'Wisconsin' },
  { code: 'WY', name: 'Wyoming' },
];

const ContactInformationPage = ({ onSelect, onSubmit, hidePaymentMethod }) => {
 const [firstName, setFirstName] = useState("")
 const [lastName, setLastName] = useState("")
 const [phoneNumber, setPhoneNumber] = useState("")
 const [email, setEmail] = useState("")
 const [shippingAddress, setShippingAddress] = useState("");
 const [city, setCity] = useState("")
 const [state, setState] = useState("")
 const [zipCode, setZipCode] = useState("");
 const [paypalEmail, setPaypalEmail] = useState("")
 const [venmoUsername, setVenmoUsername] = useState("")
 const [agreementChecked, setAgreementChecked] = useState(false);
 const [signature, setSignature] = useState("");

 const [firstNameError, setFirstNameError] = useState(false)
 const [lastNameError, setLastNameError] = useState(false)
 const [phoneNumberError, setPhoneNumberError] = useState(false)
 const [emailError, setEmailError] = useState(false)
 const [shippingAddressError, setShippingAddressError] = useState(false);
 const [cityError, setCityError] = useState(false)
 const [stateError, setStateError] = useState(false)
 const [zipCodeError, setZipCodeError] = useState(false);
 const [paypalEmailError, setPaypalEmailError] = useState(false)
 const [venmoUsernameError, setVenmoUsernameError] = useState(false)
 const [agreementCheckedError, setAgreementCheckedError] = useState(false)
 const [signatureError, setSignatureError] = useState(false);

 // Refs for scroll/focus to the first invalid field (in display order)
 const firstNameRef = useRef(null);
 const lastNameRef = useRef(null);
 const phoneNumberRef = useRef(null);
 const emailRef = useRef(null);
 const shippingAddressRef = useRef(null);
 const cityRef = useRef(null);
 const stateRef = useRef(null);
 const zipCodeRef = useRef(null);
 const agreementRef = useRef(null);
 const signatureRef = useRef(null);
 const venmoUsernameRef = useRef(null);
 const paypalEmailRef = useRef(null);
 const paymentMethodRef = useRef(null);

  const [paymentMethod, setPaymentMethod] = useState("store-credit");

  const handleSelect = (method) => {
    setPaymentMethod(method);
    setPaypalEmailError(false);
    setVenmoUsernameError(false);
  }

  function isValidEmail(email) {
  // Regular expression for validating email addresses
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  }

  // Normalize for signature COMPARISON only (never applied to payload values):
  // trim, collapse internal whitespace runs to a single space, lowercase.
  const norm = (s) => (s || '').trim().replace(/\s+/g, ' ').toLowerCase();

  // Computes each field's validity, sets all error states, scrolls+focuses the
  // first invalid field (in display order), and returns true only if everything
  // is valid.
  const validateAndReport = () => {
    const fullName = norm(`${firstName} ${lastName}`);
    const enteredSignature = norm(signature);

    const firstNameInvalid = firstName == '';
    const lastNameInvalid = lastName == '';
    const phoneNumberInvalid = phoneNumber == '';
    const emailInvalid = email == '' || !isValidEmail(email);
    const shippingAddressInvalid = shippingAddress == '';
    const cityInvalid = city == '';
    const stateInvalid = state == '';
    const zipCodeInvalid = !/^\d{5}$/.test(zipCode);
    const agreementInvalid = agreementChecked == false;
    const signatureInvalid = enteredSignature !== fullName;

    const venmoUsernameInvalid =
      !hidePaymentMethod && paymentMethod == 'Venmo' && venmoUsername.trim() == '';
    const paypalEmailInvalid =
      !hidePaymentMethod && paymentMethod == 'PayPal' && !isValidEmail(paypalEmail);
    // Payment section shown but no valid payout method selected (still the
    // default "store-credit") -> invalid.
    const paymentMethodInvalid =
      !hidePaymentMethod &&
      paymentMethod !== 'Check' &&
      paymentMethod !== 'Venmo' &&
      paymentMethod !== 'PayPal';

    // Set every field's error state (highlight invalid, clear newly-valid)
    setFirstNameError(firstNameInvalid);
    setLastNameError(lastNameInvalid);
    setPhoneNumberError(phoneNumberInvalid);
    setEmailError(emailInvalid);
    setShippingAddressError(shippingAddressInvalid);
    setCityError(cityInvalid);
    setStateError(stateInvalid);
    setZipCodeError(zipCodeInvalid);
    setAgreementCheckedError(agreementInvalid);
    setSignatureError(signatureInvalid);
    setVenmoUsernameError(venmoUsernameInvalid);
    setPaypalEmailError(paypalEmailInvalid);

    // First invalid field in display order
    const ordered = [
      [firstNameInvalid, firstNameRef],
      [lastNameInvalid, lastNameRef],
      [phoneNumberInvalid, phoneNumberRef],
      [emailInvalid, emailRef],
      [shippingAddressInvalid, shippingAddressRef],
      [cityInvalid, cityRef],
      [stateInvalid, stateRef],
      [zipCodeInvalid, zipCodeRef],
      [agreementInvalid, agreementRef],
      [signatureInvalid, signatureRef],
      [paymentMethodInvalid, paymentMethodRef],
      [venmoUsernameInvalid, venmoUsernameRef],
      [paypalEmailInvalid, paypalEmailRef],
    ];

    const firstInvalid = ordered.find(([invalid]) => invalid);

    if (firstInvalid) {
      const node = firstInvalid[1].current;
      if (node) {
        if (typeof node.scrollIntoView === 'function') {
          node.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        if (typeof node.focus === 'function') {
          node.focus({ preventScroll: true });
        }
      }
      return false;
    }

    return true;
  }

  const checkFormCompletion = () => {
    if (firstName == '') {
        return false;
    }
    if (lastName == '') {
        return false;
    }
    if (phoneNumber == '') {
        return false;
    }
    if (email == '' || !isValidEmail(email)) {
        return false;
    }
    if (shippingAddress == '') {
        return false;
    }
    if (city == '') {
        return false;
    }
    if (state == '') {
        return false;
    }
    if (!/^\d{5}$/.test(zipCode)) {
        return false;
    }

    if (agreementChecked == false) {
        return false;
    }

    const fullName = norm(`${firstName} ${lastName}`);
    const enteredSignature = norm(signature);

    // Check if signature matches the full name
    if (enteredSignature !== fullName) {
      return false;
    }

    if (hidePaymentMethod) return true;            // store-credit-only: no payout method needed
    if (paymentMethod === 'Check') return true;
    if (paymentMethod === 'Venmo') return venmoUsername.trim() !== '';
    if (paymentMethod === 'PayPal') return isValidEmail(paypalEmail);
    return false;                                   // nothing valid selected -> incomplete
  }

  // Returns true when the submit actually proceeds (form valid), false otherwise.
  const handleSubmit = (event, contactInformation, paymentMethod, agreementChecked) => {
    event.preventDefault();

    if (validateAndReport()) {
      onSubmit(contactInformation, Object.assign({}, {
        paymentMethod: paymentMethod,
        username: paymentMethod == 'Venmo' ? venmoUsername : paymentMethod == 'PayPal' ? paypalEmail : undefined
      }), agreementChecked);
      return true;
    }
    return false;
  }

  const handlePaypalEmailChange = event => {
    setPaypalEmail(event.target.value);
    setPaypalEmailError(false);
  }

  const handleVenmoUsernameChange = event => {
    setVenmoUsername(event.target.value);
    setVenmoUsernameError(false)
  }

  const handleCheck = event => {
    setAgreementChecked(!agreementChecked)
  }

  const handleSignatureChange = event => {
    let signature = event.target.value;
    setSignature(signature);

    if (signature.trim() === '') {
      setSignatureError(true);
    } else {
      // Normalize input for case and spacing differences
      const fullName = norm(`${firstName} ${lastName}`);
      const enteredSignature = norm(signature);

      // Check if signature matches the full name
      if (enteredSignature !== fullName) {
        setSignatureError(true);
      } else {
        setSignatureError(false);
      }
    }
  }

  // Keep signature validity reactive: when the name fields change after signing,
  // recompute the error so it doesn't go stale. Empty signature clears the error
  // (submit-time validation still catches empty). Guard against effect loops by
  // only setting state when the value actually changes.
  useEffect(() => {
    const shouldError =
      signature.trim() !== '' && norm(signature) !== norm(`${firstName} ${lastName}`);
    setSignatureError((prev) => (prev !== shouldError ? shouldError : prev));
  }, [firstName, lastName, signature]);

  const isFormComplete = checkFormCompletion();
  console.log("IS FORM COMPLETE: ", isFormComplete);

  const contactInformationPageStyle = hidePaymentMethod ? { paddingBottom: 0 }: null;
  const paymentMethodPageStyle = { paddingTop: 0 };

  console.log("SHOULD HIDE PAYMENT METHOD: ", hidePaymentMethod);
  return (
    <div>
      <div className="checkout-page" style={contactInformationPageStyle}>
        <Grid>
              <Typography gutterBottom variant="h5">
                Contact Information
            </Typography>
              <Typography variant="body2" color="textSecondary" component="p" gutterBottom>
                Fill out the form for us to create your shipping label.
            </Typography>
              <form autoComplete="on">
                <Grid container spacing={1}>
                  <Grid xs={12} sm={6} item>
                    <TextField inputRef={firstNameRef} name="firstName" autoComplete="given-name" placeholder="Enter first name" label="First Name" variant="outlined" value={firstName} error={firstNameError} onChange={e => { setFirstName(e.target.value); setFirstNameError(false); }} fullWidth required />
                  </Grid>
                  <Grid xs={12} sm={6} item>
                    <TextField inputRef={lastNameRef} name="lastName" autoComplete="family-name" placeholder="Enter last name" label="Last Name" variant="outlined" value={lastName} error={lastNameError} onChange={e => { setLastName(e.target.value); setLastNameError(false); }} fullWidth required />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField inputRef={phoneNumberRef} name="phone" autoComplete="tel" type="tel" inputProps={{ inputMode: 'tel' }} placeholder="Enter phone number" label="Phone" variant="outlined" value={phoneNumber} error={phoneNumberError} onChange={e => { setPhoneNumber(e.target.value); setPhoneNumberError(false); }} fullWidth required />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField inputRef={emailRef} name="email" autoComplete="email" type="email" placeholder="Enter email" label="Email" variant="outlined" value={email} error={emailError} onChange={e => { setEmail(e.target.value); setEmailError(false); }} fullWidth required />
                  </Grid>
                  <Grid xs={12} sm={12} item>
                    <TextField inputRef={shippingAddressRef} name="address" autoComplete="address-line1" label="Shipping Address" placeholder="Enter shipping address" variant="outlined" value={shippingAddress} error={shippingAddressError} onChange={e => { setShippingAddress(e.target.value); setShippingAddressError(false); }} fullWidth required />
                  </Grid>
                  <Grid xs={12} sm={6} item>
                    <TextField inputRef={cityRef} name="city" autoComplete="address-level2" label="City" placeholder="Enter City" variant="outlined" value={city} error={cityError} onChange={e => { setCity(e.target.value); setCityError(false); }} fullWidth required />
                  </Grid>
                  <Grid xs={12} sm={3} item>
                    <Autocomplete
                      options={states}
                      getOptionLabel={(o) => o.name}
                      isOptionEqualToValue={(opt, val) => opt.code === val.code}
                      value={states.find((s) => s.code === state) || null}
                      onChange={(_, newVal) => { setState(newVal ? newVal.code : ''); setStateError(false); }}
                      sx={{ '& .MuiAutocomplete-inputRoot': { paddingTop: 0, paddingBottom: 0 }, '& .MuiAutocomplete-input': { paddingTop: '16.5px', paddingBottom: '16.5px' } }}
                      renderInput={(params) => <TextField {...params} inputRef={stateRef} name="state" autoComplete="address-level1" label="State" placeholder="Search state" error={stateError} required fullWidth />}
                    />
                  </Grid>
                  <Grid xs={12} sm={3} item>
                    <TextField inputRef={zipCodeRef} name="zip" autoComplete="postal-code" label="Zip Code" placeholder="Enter zip code" variant="outlined" value={zipCode} error={zipCodeError} onChange={e => { setZipCode(e.target.value); setZipCodeError(false); }} inputProps={{ maxLength: 5, inputMode: 'numeric', pattern: '[0-9]{5}' }} fullWidth required />
                  </Grid>
                  <Grid ref={agreementRef} xs={12} sm={12} item style={{ marginTop: hidePaymentMethod ? "16px" : "0"}}>
                    <FormControlLabel required control={<Checkbox checked={agreementChecked} onChange={e => handleCheck(e)} sx={agreementCheckedError ? { color: 'error.main' } : undefined} />} label="I hereby agree that the items being sold are fully functional and are in what can reasonably considered good condition." />
                  </Grid>
                  <Grid xs={12} sm={12} item>
                    <TextField
                      inputRef={signatureRef}
                      name="signature"
                      autoComplete="off"
                      label="Signature"
                      placeholder="Sign your name"
                      variant="outlined"
                      value={signature}
                      error={signatureError}
                      onChange={e => handleSignatureChange(e)}
                      helperText={signatureError ? "Signature must match your First and Last name above." : "Your signature must exactly match your First and Last name above."}
                      fullWidth
                      required
                      InputProps={{
                        style: { fontFamily: "'Dancing Script', cursive" }
                      }}
                    />
                  </Grid>
                </Grid>
              </form>
        </Grid>
      </div>
      <PaymentMethodPage onSelect={handleSelect} onSubmit={(event) => handleSubmit(event, {
        firstName,
        lastName,
        phoneNumber,
        email,
        shippingAddress,
        city,
        state,
        zipCode
      }, paymentMethod, agreementChecked)}
      selectedPaymentMethod={paymentMethod}
      paypalEmail={paypalEmail}
      paypalEmailError={paypalEmailError}
      venmoUsername={venmoUsername}
      venmoUsernameError={venmoUsernameError}
      agreementCheckedError={agreementCheckedError}
      onPaypalEmailChange={handlePaypalEmailChange}
      onVenmoUsernameChange={handleVenmoUsernameChange}
      venmoUsernameRef={venmoUsernameRef}
      paypalEmailRef={paypalEmailRef}
      paymentMethodRef={paymentMethodRef}
      formComplete={isFormComplete}
      hidePaymentMethod={hidePaymentMethod}
      paymentMethodPageStyle={paymentMethodPageStyle}
      />
    </div>
  );
}

export default ContactInformationPage;
